/* eslint-disable no-unused-expressions */
import React from "react";

import * as tasks from "../../CatalogTasks/operations";
import BootstrapTable from "react-bootstrap-table-next";
import PDFExport from "../../../helper/export-pdf";
import "react-awesome-lightbox/build/style.css";
import {
  Card,
  Container,
  Col,
  Row,
  Spinner,
} from "react-bootstrap";
import moment from "moment";
import overlayFactory from "react-bootstrap-table2-overlay";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../styles/app/pages/CampaingPreview.scss";

export default function Tasks(props) {
  const _tasks = props.tasks.sort((a, b) => {
    if (a.name > b.name) { return 1 }
    if (a.name < b.name) { return -1 }
    return 0
  })
  return (
    <Card className="p-4 rounded-xl shadow-sm" style={{ minHeight: "600px" }}>
      <Container fluid>
        <Row className="w-100 justify-content-between p-2" >
          <div className="col-6 w-100 justify-content-end d-flex ">
            <h1>
              TASKS
            </h1>
          </div>
          <PDFExport
            columns={tasks.columns
              .map((col) => col.dataField)
              .filter((col) => col !== "input_type")}
            data={_tasks.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
            name="tasks"
            sign={
              props.campaign.name +
              "\n" +
              moment(props.campaign.start_date).format("MMMM/DD/YY") +
              "-" +
              moment(props.campaign.end_date).format("MMMM/DD/YY")
            }
          >
            <button className="btn btn-warning font-weight-bolder mx-2">
              Export Data
            </button>
          </PDFExport>
        </Row>

        <Row>
          <Col>
            {!props.queryng ? (
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center"
                bootstrap4
                hover
                striped
                keyField="uid"
                data={_tasks.map((doc, i) => ({
                  count: Number(i) + 1,
                  ...doc,
                }))}
                columns={tasks.columns}
                loading={props.queryng}
                overlay={overlayFactory({ spinner: true })}
                noDataIndication={
                  <div className="mr-2 text-muted">No records found</div>
                }
              ></BootstrapTable>
            ) : (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
          </Col>
        </Row>
      </Container>
    </Card>
  );
}